import React, { useState, useEffect } from 'react';
import { useMsal } from "@azure/msal-react";
import { DataGrid, GridToolbarQuickFilter } from "@mui/x-data-grid";
import { Box, Modal, Button, IconButton, Tooltip, Typography, Alert } from '@mui/material';
import LinearProgress from "@mui/material/LinearProgress";
import { styled } from "@mui/material/styles";
import { fetchDesignerWorkItems } from "../Redux/Designer";
import { useDispatch, useSelector } from 'react-redux';
import Design from './Design';
import SendIcon from '@mui/icons-material/Send';
import axios from 'axios';
import { baseURL } from '../Constant';
import "./CommunicationTable.css";
const StyledButton = styled(Button)(({
  theme
}) => ({
  color: "black",
  textTransform: "none",
  border: "solid 1px #6019F9",
  borderRadius: "20px",
  backgroundColor: "white",
  padding: "0px !important",
  "&:hover": {
    backgroundColor: "white"
  }
}));
function formatTimestamp(timestamp) {
  const date = new Date(timestamp);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
  const year = String(date.getFullYear()).slice(-2); // Get last two digits of the year

  return `${day}-${month}-${year}`;
}
const CommunicationTable = () => {
  const {
    instance
  } = useMsal();
  const activeAccount = instance.getActiveAccount();
  const [user, setUser] = useState(null);
  const [openRedirectionAlert, setOpenRedirectionAlert] = useState(false);
  const [submissionResAlert, setSubmissionResAlert] = useState(null);
  const [openConfirmation, setConfirmation] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [modalRecord, setModalRecord] = useState();
  const [currComm, setCurrComm] = useState(null);
  const [submissionInProgress, setSubmissionInProgress] = useState(false);
  const data = useSelector(state => state.designer.commData);
  const dispatch = useDispatch();
  const getEditLink = async fileName => {
    setOpenRedirectionAlert(true);
    try {
      const response = await axios.get(`${baseURL}/open-ppt-in-onedrive/edit`, {
        params: {
          blobname: fileName,
          eid: user
        },
        headers: {
          Authorization: localStorage.getItem('token'),
          "Content-Type": "application/json"
        }
      });
      const {
        editLink
      } = response.data;
      if (editLink) {
        window.open(editLink, '_blank');
      } else {
        alert('Could not generate OneDrive link.');
      }
    } catch (err) {
      console.error('Failed to open PPT in OneDrive:', err);
    } finally {
      setOpenRedirectionAlert(false);
    }
  };
  const handleOpen = record => {
    setOpenModal(true);
    setModalRecord(record);
  };
  const handleClose = () => {
    setOpenModal(false);
  };
  const handleBackClick = () => {
    setCurrComm(null);
    // if (setL2 !== undefined) setL2("");
  };
  const helperFunc = rowData => {
    setCurrComm({
      id: rowData.id,
      designContent: rowData.designContent
    });
    // if (setL2 !== undefined) setL2(rowData.name);
  };
  const handleSharing = async rowData => {
    setSubmissionInProgress(true);
    try {
      const {
        id,
        pptname,
        assignedBy,
        assignedTo
      } = rowData;
      const responseOfVerification = await axios.post(`${baseURL}/designer/checkIfWorked`, {
        eid: user,
        fileName: pptname
      }, {
        headers: {
          'Content-Type': 'application/json'
        }
      });
      if (responseOfVerification.status === 200) {
        await axios.post(`${baseURL}/designer/submit-for-review`, {
          id,
          eid: user,
          blobName: pptname,
          assignedBy,
          assignedTo
        }, {
          headers: {
            Authorization: localStorage.getItem('token'),
            'Content-Type': 'application/json'
          }
        });
        setSubmissionResAlert({
          severity: "success",
          msg: "Submitted for review successfully!"
        });
      }
    } catch (error) {
      if (error.response) {
        const status = error.response.status;
        const message = error.response.data;
        if (status === 404) {
          console.warn("⚠️", message);
          setSubmissionResAlert({
            severity: "warning",
            msg: message
          });
        } else if (status === 500) {
          console.error("❌", message);
          setSubmissionResAlert({
            severity: "error",
            msg: message
          });
        } else {
          console.error("Unhandled error:", message);
          setSubmissionResAlert({
            severity: "error",
            msg: message
          });
        }
      } else {
        console.error("Network error or server didn't respond");
        setSubmissionResAlert({
          severity: "error",
          msg: "Network error or server didn't respond"
        });
      }
    } finally {
      setConfirmation(null);
      setSubmissionInProgress(false);
    }
  };

  // button for opening the design screen
  const buttonGenerator = rowData => {
    return <Button variant="text" onClick={() => helperFunc(rowData)} className="migrated-style-communicationtable-585fd0-1">
        Gen. Images
        </Button>;
  };
  // button for sending to approver
  const buttonToShare = rowData => {
    return <Tooltip title="Send for approval">
      <IconButton onClick={() => setConfirmation(rowData)}>
        <SendIcon />
      </IconButton>
    </Tooltip>;
  };
  useEffect(() => {
    dispatch(fetchDesignerWorkItems(user));
  }, [user]);
  useEffect(() => {
    if (activeAccount) {
      setUser(activeAccount.idTokenClaims.enterpriseID);
    }
  }, [activeAccount]);
  const columns = [{
    field: 'serialNumber',
    align: 'center',
    headerName: <div>SI#</div>,
    width: 50,
    renderCell: params => params.api.getSortedRowIds().indexOf(params.id) + 1
  }, {
    field: 'subcategory',
    headerName: <div>Content</div>,
    width: 80
  }, {
    field: 'mailtype',
    headerName: <div>Sub-Type</div>,
    width: 90
  }, {
    field: 'programname',
    headerName: <div>Program Name</div>,
    width: 225
  },
  // {
  //   field: 'design_content',
  //   headerName: <div >Design</div>,
  //   width: 90, // Fixed width
  //   renderCell: (params) => buttonGenerator(params.row),
  // },
  {
    field: 'pptname',
    headerName: <div>PPT URL</div>,
    width: 70,
    valueGetter: value => {
      if (value?.row?.pptname !== null) {
        return value?.row?.pptname;
      } else return "NA";
    },
    renderCell: params => params?.row?.pptname !== "NA" ? <Button sx={{
      textTransform: "none",
      textDecoration: "underline",
      color: "blue"
    }} onClick={() => getEditLink(params?.row?.pptname)}>Link</Button> : params?.row?.pptname
  }, {
    field: "fileStatus",
    headerName: <div> File Status</div>,
    width: 90
  }, {
    field: 'assignedBy',
    headerName: <div>Assigned By</div>,
    width: 100
  }, {
    field: "createdAt",
    headerName: <div>Created At</div>,
    renderCell: params => <div>{params.row.createdAt ? formatTimestamp(params.row.createdAt) : "Not known"}</div>,
    width: 85
  }, {
    field: 'action',
    headerName: <div className="migrated-style-communicationtable-585fd0-2">Action</div>,
    width: 75,
    renderCell: params => buttonToShare(params.row)
  }];
  return <>
  {openRedirectionAlert && <Alert severity="info" sx={{
      mb: 2
    }}>
      Please wait! You are being redirected
    </Alert>}
    {submissionResAlert && <Alert onClose={() => setSubmissionResAlert(null)} severity={submissionResAlert.severity} sx={{
      mb: 2
    }}>
      {submissionResAlert.msg}
    </Alert>}
    {currComm ? <div>
        <Design campaignMetaData={currComm} />
        <button onClick={handleBackClick} className='back-btn'>
          <img src="/Images/ApprovalPage/backbutton.png" className="migrated-style-communicationtable-585fd0-3" />
        </button>
      </div> : <div className="datagrid-campaign-container migrated-style-communicationtable-585fd0-4">
        <DataGrid rows={data} columns={columns} pageSize={10} rowsPerPageOptions={[10]} showCellBorders disableSelectionOnClick disableColumnMenu disableExtendRowFullWidth={true}
      // sortModel={sortModelNew}
      // onSortModelChange={handleSortModelChange}
      sortingOrder={['asc', 'desc']} sx={{
        "& .MuiDataGrid-columnHeader": {
          backgroundColor: "#022278",
          // Customize the header background color
          color: "white" // Customize text color
        },
        "& .MuiDataGrid-root": {
          width: "100%" // Ensure DataGrid spans the full width
        },
        "& .MuiDataGrid-sortIcon": {
          color: "#fff" // Customize the sorter (sort icon) color
        },
        "& .MuiDataGrid-columnHeader": {
          position: "sticky",
          top: 0,
          backgroundColor: "#022278",
          // Optional: to ensure it’s visible on scroll
          color: "#fff"
        },
        "& .MuiDataGrid-columnHeaders": {
          width: "var(--DataGrid-rowWidth)"
        },
        "& .MuiDataGrid-row": {
          backgroundColor: "white",
          width: "calc(100% - 2px)"
        },
        "& ..MuiDataGrid-topContainer": {
          width: "700px !important"
        }
      }} slots={{
        toolbar: GridToolbarQuickFilter
      }} className="migrated-style-communicationtable-585fd0-5" />
      </div>}  
      <Modal hideBackdrop open={openModal} onClose={handleClose} aria-labelledby="child-modal-title" closeAfterTransition aria-describedby="child-modal-description" className="modal-container">
              <Box className="model">
                <div className="model_heading">
                  <h5 className="paramodel">Details</h5>
                  <span className="close_btn_model" onClick={handleClose} tabIndex={0}>
                    Close
                  </span>
                </div>
                <hr />
                <div className="program-modal-details">
                  {/* <div className="program-details-wrap">
                    <p className="program-details-header">Design Content: </p>
                    <p className="program-details-value">
                      {modalRecord?.designContent}
                    </p>
                   </div> */}
                  <div className="program-details-wrap">
                    <p className="program-details-header">Assigned To: </p>
                    <p className="program-details-value">
                      {modalRecord?.assignedTo}
                    </p>
                  </div>
                  <div className="program-details-wrap">
                    <p className="program-details-header">Assigned By: </p>
                    <p className="program-details-value">
                      {modalRecord?.assignedBy}
                    </p>
                  </div>
                   {/* <div className="program-details-wrap">
                    <p className="program-details-header">Send to approver:</p>
                    <p className="program-details-value">
                      <Button variant='contained' sx={{fontSize:"12px",textTransform:"none"}} onClick={handleSend}>Send to Approver&nbsp;<SendIcon sx={{fontSize:"12px"}}/></Button>
                    </p>
                    </div> */}
                  <div className="program-details-wrap">
                    <p className="program-details-header">Date & Time Created: </p>
                    <p className="program-details-value">
                      {modalRecord?.createdAt}
                    </p>
                  </div>
                </div>
               </Box> 
       </Modal>
       <Modal open={openConfirmation == null ? false : true} onClose={() => setConfirmation(null)}>
      <Box sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: "38vw",
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 3,
        borderRadius: 2
      }}>
        <Typography sx={{
          fontSize: "16px",
          fontFamily: "Graphik-Regular",
          marginBottom: "15px",
          textAlign: "center",
          fontWeight: "600"
        }}>
          {submissionInProgress ? "Please wait! Submission is in progress." : "Are you sure you want to send this design for approval?"}
        </Typography>
        {submissionInProgress ? <LinearProgress className="loader" /> : <Box sx={{
          display: "flex",
          justifyContent: "center",
          gap: 2
        }}>
              <StyledButton onClick={() => handleSharing(openConfirmation)}>Yes</StyledButton>
              <StyledButton onClick={() => setConfirmation(null)}>Cancel</StyledButton>
            </Box>}

      </Box>
      </Modal> 
     
      </>;
};
export default CommunicationTable;
